"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResourceContext = useResourceContext;
exports.useResourceContextProvider = useResourceContextProvider;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _util = require("../util");

var _firebase = require("../firebase");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ResourcesContext = /*#__PURE__*/_react.default.createContext({});

function useResourceContext() {
  return (0, _react.useContext)(ResourcesContext);
}

function useResourceContextProvider() {
  // fetch from firestore
  var _useMemoryDB = (0, _firebase.useMemoryDB)(),
      _resources = _useMemoryDB.resources,
      modules = _useMemoryDB.modules,
      seriesList = _useMemoryDB.seriesList;

  var online = (0, _firebase.useOnlineStatus)(); // add "cached" marker to resources

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      resources = _useState2[0],
      setResources = _useState2[1];

  (0, _react.useEffect)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var cache, resourceEntries, isCached, r, _r;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return self.caches.open("media");

          case 3:
            cache = _context.sent;
            resourceEntries = Object.entries(_resources);
            _context.next = 7;
            return Promise.all(resourceEntries.map(function (_ref2, index) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  key = _ref3[0],
                  resource = _ref3[1];

              return cache.match((0, _firebase.firestoreCacheKey)(resource === null || resource === void 0 ? void 0 : resource.location));
            }));

          case 7:
            isCached = _context.sent;
            r = Object.fromEntries(resourceEntries.map(function (_ref4, index) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  key = _ref5[0],
                  resource = _ref5[1];

              return [key, _objectSpread(_objectSpread({}, resource), {}, {
                isCached: !!isCached[index]
              })];
            }));
            setResources(r);
            _context.next = 16;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            // assume not cached, and it will error to try to look them up
            // but we still need a valid resources object
            _r = (0, _util.objectMap)(_resources, function (k, v) {
              return [k, _objectSpread(_objectSpread({}, v), {}, {
                isCached: false
              })];
            });
            setResources(_r);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  })), [_resources, online]); // TODO: should also update whenever cache contents is updated!
  // generate derivative resources

  var generatedResources = useGeneratedResources({
    resources: resources,
    modules: modules,
    seriesList: seriesList
  });

  var allResources = _objectSpread(_objectSpread({}, resources), generatedResources);

  var offlineResources = (0, _util.objectFilter)(allResources, function (k, v) {
    return v.isCached;
  });

  var _useNormalizedQuery = useNormalizedQuery({
    allResources: allResources,
    resources: resources,
    modules: modules,
    seriesList: seriesList
  }),
      _useNormalizedQuery2 = _slicedToArray(_useNormalizedQuery, 2),
      query = _useNormalizedQuery2[0],
      setQuery = _useNormalizedQuery2[1]; // share this as all-or-nothing -- saves on checking each bit alone


  var ready = query && (0, _util.ArrayAll)([resources, modules, seriesList, generatedResources, allResources], function (x) {
    return Object.keys(x).length > 0;
  }); // query can be empty, but others cannot

  var partialContext = {
    query: query,
    resources: resources,
    modules: modules,
    seriesList: seriesList,
    generatedResources: generatedResources,
    allResources: allResources,
    offlineResources: offlineResources
  };
  var context = ready ? partialContext : {};
  return [function (props) {
    return /*#__PURE__*/_react.default.createElement(ResourcesContext.Provider, {
      value: context
    }, props.children);
  }, setQuery];
}

function useNormalizedQuery(_ref6) {
  var allResources = _ref6.allResources,
      resources = _ref6.resources,
      modules = _ref6.modules,
      seriesList = _ref6.seriesList;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var query = Object.fromEntries(searchParams.entries());

  var setQuery = function setQuery(query) {
    setSearchParams((0, _util.objectFilter)(query, function (k, v) {
      return v != undefined;
    }));
  };

  var normalized = query;
  if (!query) return [{}, setQuery];
  if (!allResources) return [{}, setQuery];

  if (query.id in allResources) {
    // id based query
    normalized.series = allResources[query.id].series;
    normalized.module = allResources[query.id].module;
  } else if (allResources && query.series in seriesList && query.module in modules) {
    var _Object$keys$filter;

    // series & module based query
    normalized.id = (_Object$keys$filter = Object.keys(allResources).filter(function (k) {
      return allResources[k].series === query.series && allResources[k].module === query.module;
    })) === null || _Object$keys$filter === void 0 ? void 0 : _Object$keys$filter[0];
  } else if (query.series || query.module) {
    var _Object$keys$filter2;

    // handle incomplete query
    normalized.id = (_Object$keys$filter2 = Object.keys(allResources).filter(function (k) {
      return allResources[k].series === query.series || allResources[k].module === query.module;
    })) === null || _Object$keys$filter2 === void 0 ? void 0 : _Object$keys$filter2[0];
  } else {
    // else empty or invalid query
    normalized = {};
    if (Object.keys(query).length > 0) console.warn("Unexpected query", query);
  }

  return [normalized, setQuery];
} // create generated resources without a db entry


function useGeneratedResources(_ref7) {
  var resources = _ref7.resources,
      modules = _ref7.modules,
      seriesList = _ref7.seriesList;
  return (0, _react.useMemo)(function () {
    if (!(resources && modules && seriesList)) return undefined;
    var moduleKeys = Object.keys(modules);
    var generatedSeries = Object.entries(seriesList).filter(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          k = _ref9[0],
          v = _ref9[1];

      return v.format == "generated";
    }).map(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
          k = _ref11[0],
          v = _ref11[1];

      return k;
    });
    var generatedResources = moduleKeys.map(function (module) {
      return generatedSeries.map(function (series) {
        return getGeneratedVideoMetadata({
          module: module,
          series: series,
          resources: resources,
          seriesList: seriesList
        });
      }).filter(function (k) {
        return k;
      }); // generator above returns false when invalid generator data
    }).reduce(function (all, cur) {
      return [].concat(_toConsumableArray(all), _toConsumableArray(cur));
    }, []); // flatten the 2d array map

    return Object.fromEntries(generatedResources);
  }, [resources, modules, seriesList]);
}

function getGeneratedVideoMetadata(_ref12) {
  var series = _ref12.series,
      module = _ref12.module,
      resources = _ref12.resources,
      seriesList = _ref12.seriesList;
  var seriesData = seriesList[series];
  var format = seriesData.generatorFormat && JSON.parse(seriesData.generatorFormat);
  var referencedSeries = format.loop && [format.loop] || (format === null || format === void 0 ? void 0 : format.interlace);
  var referencedVideos = Object.entries(resources).filter(function (_ref13) {
    var _ref14 = _slicedToArray(_ref13, 2),
        k = _ref14[0],
        v = _ref14[1];

    return v.module === module && referencedSeries.includes(v.series);
  }); // check if invalid conditions for generator

  if (!(format && referencedVideos.length === referencedSeries.length && (0, _util.ArrayAll)(referencedVideos, function (_ref15) {
    var _ref16 = _slicedToArray(_ref15, 2),
        k = _ref16[0],
        v = _ref16[1];

    return !!v.timestamps;
  }))) return undefined; // if(referencedVideos.length == 1)
  //   return [`${module}-bythebook-${series}-generated`, {...referencedVideos[0], ...seriesData, series, module}]
  // else

  return ["".concat(module, "-bythebook-").concat(series, "-generated"), _objectSpread(_objectSpread({
    referencedVideos: Object.fromEntries(referencedVideos),
    isCached: (0, _util.ArrayAll)(referencedVideos, function (_ref17) {
      var _ref18 = _slicedToArray(_ref17, 2),
          k = _ref18[0],
          v = _ref18[1];

      return v.isCached;
    })
  }, seriesData), {}, {
    series: series,
    module: module
  })];
}